import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

type ContainerProps = {
  error?: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  height: fit-content;

  ${(props) =>
    props.error &&
    css`
      border: 1px solid red;
    `}
`;

export const Error = styled(Tooltip)`
  position: absolute;

  top: 0;
  right: 0;

  margin-top: 0.8rem;
  margin-right: 4.6rem;

  /* height: 2rem;
  margin-left: 1.6rem; */

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
